import React from 'react';
import { Row, Col, Result, Card, Divider } from 'antd';
import { JobExecutionResponse } from '../../../services/accounting';
import Text from 'components/Text';
import Title from 'components/Title';
import Button from 'components/Button';
import { API_URLS } from 'utils/config';
import { downloadBlobFile } from '../../../utils/utils2';

const getUrl = (
  jobid: number | string,
  filetype: string,
  entity?: string,
  mode?: string,
  indexfile?: number
): string => {
  if (mode === 'PRINTING') {
    return `${API_URLS.PRINTING}/api/job/download?jobid=${jobid}&filetype=${filetype}`;
  } else if (entity === 'PAYMENT' || mode === 'PAYMENT') {
    return `${API_URLS.PAYMENT}/api/job/download?jobid=${jobid}&filetype=${filetype}`;
  } else if (entity === 'CINVOICE') {
    return `${API_URLS.CLIENT_INVOICE}/api/job/download?jobid=${jobid}&filetype=${filetype}`;
  } else if (entity === 'SINVOICE') {
    return `${API_URLS.SUPPLIER_INVOICE}/api/supplier/job/download?jobid=${jobid}&filetype=${filetype}`;
  } else if (entity === 'COLLECTION') {
    return `${API_URLS.COLLECTION}/api/collection/job/download?jobid=${jobid}&filetype=${filetype}`;
  } else if (entity === 'CONFIG') {
    return `${API_URLS.CONFIGURATION_SERVICE}/api/job/download?jobid=${jobid}&filetype=${filetype}`;
  } else if (entity === 'ASSETCONFIG') {
    return `${API_URLS.ASSETS_CONFIG}/api/job/download?jobid=${jobid}&filetype=${filetype}`;
  } else {
    if (indexfile) {
      return `${API_URLS.ACCOUNTING}/api/job/download?jobid=${jobid}&filetype=${filetype}&indexfile=${indexfile}`;
    } else {
      return `${API_URLS.ACCOUNTING}/api/job/download?jobid=${jobid}&filetype=${filetype}`;
    }
  }
};

type JobResultProps = {
  jobResponse: JobExecutionResponse | undefined;
  entity?: string;
  mode?: string;
  hideOutputFile?: boolean;
  indexfile?: number;
  filetype?:string;
};

const JobResult = ({
  jobResponse,
  entity,
  mode,
  hideOutputFile,
  indexfile,
  filetype
}: JobResultProps) => {
  return (
    <Card bordered>
      <Card.Grid style={{ width: '100%' }}>
        {jobResponse && (
          <Row gutter={[8, 8]}>
            <Col xs={24}>
              <Title level={4} comcode="result" />
            </Col>
          </Row>
        )}

        {jobResponse?.outputfile && !hideOutputFile && (
          <>
            <Row>
              <Col xs={24} md={6}>
                <Text strong comcode="outputFile" />
              </Col>
              <Col xs={24} md={14}>
                {jobResponse.outputfile}
              </Col>
              <Col xs={24} md={4}>
                <Button
                  comcode="download"
                  type="primary"
                  onClick={() =>
                    downloadBlobFile(
                      jobResponse?.outputfile,
                      getUrl(
                        jobResponse.jobid,
                        filetype ?? 'OUTPUT',
                        entity,
                        mode,
                        indexfile
                      )
                    )
                  }
                  style={{ width: 200, height: 60 }}
                />
              </Col>
            </Row>
            <Divider />
          </>
        )}
        {jobResponse?.logfile && (
          <>
            <Row>
              <Col xs={24} md={6}>
                <Text strong comcode="logFfile" />
              </Col>
              <Col xs={24} md={14}>
                {jobResponse.logfile}
              </Col>
              <Col xs={24} md={4}>
                <Button
                  comcode="download"
                  type="primary"
                  onClick={() =>
                    downloadBlobFile(
                      jobResponse?.logfile,
                      getUrl(jobResponse.jobid, 'LOG', entity, mode)
                    )
                  }
                  style={{ width: 200, height: 60 }}
                />
              </Col>
            </Row>
            <Divider />
          </>
        )}
        {jobResponse?.errorfile && (
          <>
            <Row>
              <Col xs={24} md={6}>
                <Text strong comcode="errorFile" />
              </Col>
              <Col xs={24} md={14}>
                toto.err
              </Col>
              <Col xs={24} md={4}>
                <Button
                  comcode="download"
                  type="primary"
                  onClick={() =>
                    downloadBlobFile(
                      jobResponse?.errorfile,
                      getUrl(jobResponse.jobid, 'ERROR', entity, mode)
                    )
                  }
                  style={{ width: 200, height: 60 }}
                />
              </Col>
            </Row>
            <Divider />
          </>
        )}

        {jobResponse && (
          <div style={{ textAlign: 'center' }}>
            <Result
              status={jobResponse.code === '200' ? 'success' : 'info'}
              title={jobResponse.message}
              subTitle={jobResponse.description}
            />
          </div>
        )}
      </Card.Grid>
    </Card>
  );
};

export default JobResult;
